import {get} from 'lodash'

export const getCSRFToken = (): string => {
  return get(document.querySelector('meta[name=csrf]'), 'content', '')
}
